import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { changeFormFieldValue, removeFieldError, setFieldError, updateFields } from 'apps/auth/actions/formAction';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import Form from 'apps/auth/components/form-multi/Form';
import InputText from 'apps/auth/components/form-multi/InputText';
import { REQ_ERROR } from 'apps/auth/constants/Constants';
import { AMOUNT_FROM, AMOUNT_TO, PROMO_CODE_FIELD } from 'apps/auth/constants/fieldsName';
import update from 'apps/auth/helpers/Immutability';

const SaveMoneyPopup = ({ popupRef = null, ...props }) => {
    const codeApplied = useRef();

    useEffect(() => {
        codeApplied.current = false;
        return () => {
            if (!codeApplied.current) {
                props.changeFormFieldValue(props.formName, '', PROMO_CODE_FIELD);
                props.removeFieldError(props.formName, PROMO_CODE_FIELD);
            }
        };
    }, []);

    const submitHandler = (fields, json) => {
        if (json && json.extra?.showError && json.errors) {
            codeApplied.current = false;
            Object.keys(json.errors).forEach((name) => {
                props.setFieldError(props.formName, name, json.errors[name]);
            });
        } else {
            codeApplied.current = true;
            const amountFields = {};
            amountFields[AMOUNT_FROM] = update(props.amountFrom, { value: { $set: json.extra.commission.from } });
            amountFields[AMOUNT_TO] = update(props.amountTo, { value: { $set: json.extra.commission.to } });
            props.updateFields(props.formName, amountFields);
            popupRef.current?.close();
        }
    };

    const onSubmitButtonClick = async (e) => {
        const field = props.fields[PROMO_CODE_FIELD];
        // clear leading space before validation and sending
        const value = typeof field.value === 'string' ? field.value.trimStart() : field.value;
        if (value !== field.value) {
            props.changeFormFieldValue(props.formName, value, PROMO_CODE_FIELD);
        }
        if (!value || value.length === 0) {
            props.setFieldError(props.formName, PROMO_CODE_FIELD, props.reqErrorText);
            e.preventDefault();
        } else if (props.beforeSaveMoneyCodeSubmit) {
            await props.beforeSaveMoneyCodeSubmit();
        }
    };

    return (
        <ComplexPopup
            primaryButtonType="submit"
            primaryButtonForm="save_money_form"
            primaryButtonText={props.add}
            onPrimaryButtonClick={onSubmitButtonClick}
            textCenter
            popupRef={popupRef}
        >
            <Form
                id="save_money_form"
                formName={props.formName}
                action={props.promoCodeFetchUrl}
                validateForm={false}
                getCanonicalPath={true}
                beforeSubmit={(e) => e.stopPropagation()}
                onSubmitHandler={submitHandler}
            >
                <ComplexPopupRow>{props.headerPromoCode}</ComplexPopupRow>
                {props.fields[PROMO_CODE_FIELD] && <InputText formName={props.formName} field={props.fields[PROMO_CODE_FIELD]} focus={true} isNewInput />}
            </Form>
        </ComplexPopup>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        fields: state.form[ownProps.formName].fields,
        promoCode: state.form[ownProps.formName].fields[PROMO_CODE_FIELD],
        amountFrom: state.form[ownProps.formName].fields[AMOUNT_FROM],
        amountTo: state.form[ownProps.formName].fields[AMOUNT_TO],
        reqErrorText: state.messages.jsMessages[REQ_ERROR],
        add: state.messages.pageMessages.addCodeAdd,
        headerPromoCode: state.messages.pageMessages.headerPromoCode,
    };
};

SaveMoneyPopup.propTypes = {
    promoCodeFetchUrl: PropTypes.string.isRequired,
    beforeSaveMoneyCodeSubmit: PropTypes.func,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(mapStateToProps, {
    setFieldError,
    changeFormFieldValue,
    updateFields,
    removeFieldError,
})(SaveMoneyPopup);
